import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  experience: [], // New state for experience
  skills: [],
  products: [],
  certificates: [],
};

const proficiencySlice = createSlice({
  name: 'proficiency',
  initialState,
  reducers: {
    addExperience: (state, action) => {
      state.experience.push(action.payload);
    },
    updateExperience: (state, action) => {
      const { index, experience } = action.payload;
      state.experience[index] = experience;
    },
    deleteExperience: (state, action) => {
      state.experience = state.experience.filter((_, i) => i !== action.payload);
    },
    addSkill: (state, action) => {
      state.skills.push(action.payload);
    },
    updateSkill: (state, action) => {
      const { index, skill } = action.payload;
      state.skills[index] = skill;
    },
    deleteSkill: (state, action) => {
      state.skills = state.skills.filter((_, i) => i !== action.payload);
    },
    addProduct: (state, action) => {
      state.products.push(action.payload);
    },
    updateProduct: (state, action) => {
      const { index, product } = action.payload;
      state.products[index] = product;
    },
    deleteProduct: (state, action) => {
      state.products = state.products.filter((_, i) => i !== action.payload);
    },
    addCertificate: (state, action) => {
      state.certificates.push(action.payload);
    },
    updateCertificate: (state, action) => {
      const { index, certificate } = action.payload;
      state.certificates[index] = certificate;
    },
    deleteCertificate: (state, action) => {
      state.certificates = state.certificates.filter((_, i) => i !== action.payload);
    },
    resetProficiency: (state) => {
      state.experience = []; // Reset experience
      state.skills = [];
      state.products = [];
      state.certificates = [];
    },
  },
});

export const {
  addExperience,
  updateExperience,
  deleteExperience,
  addSkill,
  updateSkill,
  deleteSkill,
  addProduct,
  updateProduct,
  deleteProduct,
  addCertificate,
  updateCertificate,
  deleteCertificate,
  resetProficiency,
} = proficiencySlice.actions;

export default proficiencySlice.reducer;
